import routes from "../../../../../core/services/common/api-routes"
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthDelete, HttpAuthPutParamsPayload} from "../../../../../core/services/common/HttpRequestBuilder"

const createRecord = (payload) => {

    let result = HttpAuthPost(routes.CREATE_ROLE, payload);
    return result;
}

const getList = () => {

    let result = HttpAuthGet(routes.GET_ROLES, null);
    return result;
}

const updateRoleStatus = (parameters) => {

    let result = HttpAuthPut(routes.UPDATE_ROLE_STATUS, parameters);
    return result;
}

const deleteRole = (parameters) => {

    let result = HttpAuthDelete(routes.DELETE_ROLE, parameters);
    return result;
}

const updateRole = (parameters, payload) => {

    let result = HttpAuthPutParamsPayload(routes.UPDATE_ROLE, parameters, payload);
    return result;
}


const RoleManagementService = {
    getList, createRecord, updateRoleStatus, deleteRole, updateRole
}

export default RoleManagementService
